import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IPrizeStructure, IPrizeElement, IPrizeStake } from '@/components/game/implementations/_default/_domain/models';
import { PrizeHelper } from '@/components/game/_domain/helpers/prize-helper';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';
import { GameState, IGameStageWinnerSet, IGameStateChangedArgs, IGameRepresentationChangedArgs } from '@/components/game/_domain/models';

@Component({
  name: 'BasePrizeComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class BasePrizeComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private gameState: GameState;
  protected gamePrizeStructure: IPrizeStructure = null;
  private isVisible: boolean = true;
  public prizeHelper: PrizeHelper = new PrizeHelper();

  protected get hasMultipleStakes(): boolean {
    return this.gamePrizeStructure && this.gamePrizeStructure.stakes.length > 1;
  }

  protected handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
    this.updatePrizeVisibility();
  }

  protected handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    if (!this.isGameInPurchasingState()) {
      this.gamePrizeStructure = eventArgs.currentGameRepresentation.prizeStructure;
    }
  }

  protected handleNextGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    if (this.isGameInPurchasingState()) {
      const nextGame = eventArgs.currentGameRepresentation.nextGame;
      if (nextGame) {
        this.gamePrizeStructure = nextGame.prizeStructure;
      }
    }
  }

  private isGameInPurchasingState() {
    return this.gameState === GameState.Purchasing;
  }

  protected updatePrizeVisibility() {
    if (this.gameState === GameState.WinnersDisplayed) {
      this.isVisible = false;
    }
    else if (this.gameState === GameState.Purchasing) {
      this.isVisible = true;
    }
  }

  protected getWinnerUsernameList(winnerSet: IGameStageWinnerSet): string {
    let winners = [];
    let firstIteration = true;
    let usernameString = '';

    if (winnerSet.ticketBooks !== undefined)
    {
      const ticketBooks = winnerSet.ticketBooks || [];
      winners = ticketBooks[0].winners || [];
    }
    else
    {
      winners = winnerSet.winners || [];
    }

    winners.forEach((winner) => {
      usernameString += (firstIteration ? '' : ', ') + winner.username;
      firstIteration = false;
    });
    return usernameString;
  }

  protected formatStakeValue(stakeValueInPenceOrPrizeStake: number | IPrizeStake): string {
    return this.prizeHelper.formatStake(stakeValueInPenceOrPrizeStake);
  }

  protected formatPrizeValue(prizeValueInPenceOrPrizeElement: number | IPrizeElement): string {
    return this.prizeHelper.formatPrize(prizeValueInPenceOrPrizeElement);
  }

  protected getPrizesForSingleStake(): IPrizeElement[] {
    const prizes: IPrizeElement[] = [];
    const stake: IPrizeStake = this.getFirstGamePrizeStake();
    if (stake) {
      stake.ticketBooks.forEach((ticketBook) => {
        prizes.push(...ticketBook.prizes);
      });
    }
    return prizes;
  }

  protected getFirstGamePrizeStake(): IPrizeStake | null {
    if (this.gamePrizeStructure && this.gamePrizeStructure.stakes.length === 1) {
      return this.gamePrizeStructure.stakes[0];
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_base/_components/prize/prize.component.ts